import styled from 'styled-components'

import { Skeleton, fromMd } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  margin-bottom: 78px;
`

export const Image = styled(Skeleton).attrs({ animated: true })`
  aspect-ratio: 333 / 432;
  margin-bottom: 16px;
`

export const Line = styled(Skeleton)`
  height: 22px;
  margin-top: 8px;

  ${fromMd} {
    margin-top: 12px;
  }
`
